import { render, staticRenderFns } from "./CalculationResultRow.vue?vue&type=template&id=1b51a4b5&"
import script from "./CalculationResultRow.vue?vue&type=script&lang=js&"
export * from "./CalculationResultRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports